<div class="vi-sidebar-container"
  [ngClass]="{'show': show$ | async , 'accessible': accessibilityMode}">
  <app-vi-action-button
    class="close-button"
    [action]="closeAction"
    (actionClick)="closeSidebar()">
  </app-vi-action-button>
  <ng-container #viSidebar></ng-container>
</div>
